import { render, staticRenderFns } from "./StepSms.vue?vue&type=template&id=465cf91d&scoped=true"
import script from "./StepSms.vue?vue&type=script&lang=js"
export * from "./StepSms.vue?vue&type=script&lang=js"
import style0 from "./StepSms.vue?vue&type=style&index=0&id=465cf91d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465cf91d",
  null
  
)

export default component.exports